import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Backdrop,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFormData,
  enviaCodigo,
  validaCodigo,
  updatePassword,
} from "../../redux/slices/userSlice";

const PASOS = [
  <Box>
    <h2 style={{ fontSize: "28px" }}>_____</h2>
    <h2 style={{ fontSize: "28px" }}>
      Recuperar
      <br />
      contraseña
    </h2>
  </Box>,
  <Box>
    <h2 style={{ fontSize: "28px" }}>_____</h2>
    <h2 style={{ fontSize: "28px" }}>
      Código de
      <br />
      seguridad
    </h2>
  </Box>,
  <Box>
    <h2 style={{ fontSize: "28px" }}>_____</h2>
    <h2 style={{ fontSize: "28px" }}>Nueva contraseña</h2>
  </Box>,
];

const ResetPassword = () => {
  const dispatch = useDispatch();
  const { pasoActual, formData, loading, error } = useSelector(
    (state) => state.userReducer
  );
  const [modalAbierto, setModalAbierto] = useState(false);
  const [tiempoRestante, setTiempoRestante] = useState(600); // 10 minutos en segundos

  useEffect(() => {
    if (pasoActual === 1 && tiempoRestante > 0) {
      const timer = setInterval(() => {
        setTiempoRestante((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [pasoActual, tiempoRestante]);

  useEffect(() => {
    if (pasoActual === 1) {
      setTiempoRestante(600); // Reiniciar cuando se llega al paso 1
    }
  }, [pasoActual]);

  const formatearTiempo = () => {
    const minutos = Math.floor(tiempoRestante / 60);
    const segundos = tiempoRestante % 60;
    return `${minutos}:${segundos.toString().padStart(2, "0")}`;
  };

  const handleEnviaMail = () => {
    // Lógica para enviar el correo electrónico
    dispatch(enviaCodigo());
  };

  const handleVerificaCodigo = () => {
    // Lógica para verificar el código de seguridad
    dispatch(validaCodigo());
  };
  const handleCambiaContrasena = () => {
    // Lógica para cambiar la contraseña
    dispatch(updatePassword());
    setModalAbierto(true);
  };

  const handleIniciarSesion = () => {
    setModalAbierto(false);
    // Aquí podrías redirigir al usuario a la página de inicio de sesión
    window.location.href = `https://backoffice.levelpropiedades.cl/`;
  };

  const validarNuevaContrasena = () => {
    const { nuevaContrasena, confirmarContrasena } = formData;

    // Verificar que las contraseñas coincidan
    if (nuevaContrasena !== confirmarContrasena) return false;

    // Verificar longitud máxima de 8 caracteres
    if (nuevaContrasena?.length === 0 || nuevaContrasena?.length > 8)
      return false;

    // Verificar que tenga al menos una mayúscula
    if (!/[A-Z]/.test(nuevaContrasena)) return false;

    // Verificar que tenga al menos un número
    if (!/[0-9]/.test(nuevaContrasena)) return false;
    // Verificar que tenga al menos un caracter especial
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(nuevaContrasena))
      return false;

    return true;
  };

  const validarEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(formData.email);
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container justifyContent="center">
        <Grid
          item
          xs={12}
          sm={5}
          md={5}
          lg={5}
          xl={5}
          sx={{
            backgroundColor: "#FF9000",
            height: { xs: "auto", sm: "100vh" },
            color: "#FFFFFF",
            borderTopStyle: "solid",
            borderTopWidth: 0,
            padding: 6,
          }}
        >
          {PASOS[pasoActual]}
        </Grid>
        <Grid
          item
          xs={12}
          sm={7}
          md={7}
          lg={7}
          xl={7}
          sx={{
            backgroundColor: "#FFFFFF",
            height: "100vh",
            color: "#000000ff",
            borderTopStyle: "solid",
            borderTopWidth: 0,
            paddingLeft: { xs: 4, sm: 4, md: 4, lg: 24 },
            paddingRight: { xs: 4, sm: 4, md: 4, lg: 24 },
            paddingBottom: 4,
            overflowY: "auto",
          }}
          alignContent="center"
        >
          {error && <Alert severity="error">{error}</Alert>}
          {/* Envio de correo */}
          {pasoActual === 0 && (
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <h2 style={{ fontSize: "28px", color: "#FF9000" }}>
                  ___________________
                </h2>
                <h2 style={{ fontSize: { xs: "14px", sm: "18px" } }}>
                  Estás intentando recuperar tu contraseña, ingresa tu correo
                  electrónico y te enviaremos un código para validar esta
                  petición y crear una nueva.
                </h2>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} pt={10}>
                <TextField
                  id="email"
                  label="CORREO ELECTRÓNICO"
                  variant="standard"
                  fullWidth
                  focused
                  size="large"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: { xs: "16px", sm: "20px" },
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: { xs: "16px", sm: "20px" },
                    },
                  }}
                  value={formData.email}
                  onChange={(e) =>
                    dispatch(setFormData({ email: e.target.value }))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} pt={10}>
                <Button
                  variant="contained"
                  sx={{ borderRadius: 2, color: "#ffffff" }}
                  fullWidth
                  onClick={handleEnviaMail}
                  disabled={!validarEmail()}
                >
                  Enviar correo
                </Button>
              </Grid>
            </Grid>
          )}
          {/* Ingreso de codigo de seguridad */}
          {pasoActual === 1 && (
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <h2 style={{ fontSize: "28px", color: "#FF9000" }}>
                  ___________________
                </h2>
                <h2 style={{ fontSize: { xs: "14px", sm: "18px" } }}>
                  {`Ingresa el código de seguridad que hemos enviado al correo ${formData.email}`}
                </h2>
                <h3
                  style={{
                    fontSize: { xs: "16px", sm: "20px" },
                    color: "#FF9000",
                    marginTop: "20px",
                  }}
                >
                  Válido por: {formatearTiempo()}
                </h3>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} pt={10}>
                <TextField
                  id="security-code"
                  label="CÓDIGO DE SEGURIDAD"
                  variant="standard"
                  fullWidth
                  focused
                  size="large"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: { xs: "16px", sm: "20px" },
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: { xs: "16px", sm: "20px" },
                    },
                  }}
                  value={formData.codigoSeguridad}
                  onChange={(e) =>
                    dispatch(setFormData({ codigoSeguridad: e.target.value }))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} pt={10}>
                <Button
                  variant="contained"
                  sx={{ borderRadius: 2, color: "#ffffff" }}
                  fullWidth
                  onClick={handleVerificaCodigo}
                  disabled={tiempoRestante === 0}
                >
                  Continuar
                </Button>
              </Grid>
            </Grid>
          )}
          {/* Ingreso nueva contraseña */}
          {pasoActual === 2 && (
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <h2 style={{ fontSize: "28px", color: "#FF9000" }}>
                  ___________________
                </h2>
                <h2 style={{ fontSize: 18 }}>
                  Ingresa y confirma tu nueva contraseña. La contraseña
                  ingresada debe coincidir en ambos campos, de hasta 8
                  caracteres, con al menos una letra mayúscula y un caracter
                  especial.
                </h2>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} pt={10}>
                <TextField
                  id="new-password"
                  label="NUEVA CONTRASEÑA"
                  variant="standard"
                  fullWidth
                  focused
                  size="large"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: { xs: "16px", sm: "20px" },
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: { xs: "16px", sm: "20px" },
                    },
                  }}
                  type="password"
                  value={formData.nuevaContrasena}
                  inputProps={{ maxLength: 8 }}
                  onChange={(e) =>
                    dispatch(setFormData({ nuevaContrasena: e.target.value }))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} pt={10}>
                <TextField
                  id="confirm-password"
                  label="CONFIRMAR NUEVA CONTRASEÑA"
                  variant="standard"
                  fullWidth
                  focused
                  size="large"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: { xs: "16px", sm: "20px" },
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: { xs: "16px", sm: "20px" },
                    },
                  }}
                  type="password"
                  value={formData.confirmarContrasena}
                  inputProps={{ maxLength: 8 }}
                  onChange={(e) =>
                    dispatch(
                      setFormData({ confirmarContrasena: e.target.value })
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} pt={10}>
                <Button
                  variant="contained"
                  sx={{ borderRadius: 2, color: "#ffffff" }}
                  fullWidth
                  onClick={handleCambiaContrasena}
                  disabled={!validarNuevaContrasena()}
                >
                  Continuar
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Dialog open={modalAbierto} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{ fontSize: "24px", fontWeight: "light", color: "#000000" }}
        >
          Nueva contraseña
        </DialogTitle>
        <DialogContent>
          <Box sx={{ py: 2 }}>
            <h3 style={{ fontSize: "18px", color: "#000000", margin: 0 }}>
              ¡Hemos modificado tu contraseña con éxito!
              <br />
              Espera a que se sincronicen las contraseñas en todo el ecosistema
              Level (5 min aprox.) y vuelve a iniciar sesión. Recuerda que esta
              también será tu nueva contraseña en Levelges.
            </h3>
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: 3 }}>
          <Button
            variant="contained"
            sx={{ borderRadius: 2, color: "#ffffff" }}
            fullWidth
            onClick={handleIniciarSesion}
          >
            Iniciar Sesión
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ResetPassword;
